import { PatientProfileInfoAccordion } from '../PatientProfileInfoAccordion';
import { PatientContactInformation, PatientContactInformationProps } from './PatientContactInformation.component';

export type ContactinformationAccordianProps = PatientContactInformationProps;

export const ContactInformationAccordian: React.VFC<ContactinformationAccordianProps> = (props) => {

  return (
    <PatientProfileInfoAccordion
      title="Contact Information"
    >
      <PatientContactInformation {...props} />
    </PatientProfileInfoAccordion>
  );
};
